package com.arenaproplay.admin.ui.theme

object AppEffects {

    const val BACKGROUND_BLUR_MEDIUM = 22
    const val OVERLAY_BASE_BLUR = 53

    // ── Night Arena shadows (pure black, deeper on the dark scene) ─────────
    /** Default card elevation — subtle lift off the #05080F scene. */
    val CardElevation =
        "0 1px 2px rgba(0, 0, 0, 0.35), 0 10px 30px -12px rgba(0, 0, 0, 0.55)"

    /** Hover/active card state — slightly more pronounced. */
    val CardElevationHover =
        "0 2px 6px rgba(0, 0, 0, 0.40), 0 16px 40px -8px rgba(0, 0, 0, 0.60)"

    /** Elevated modal / popover — strong two-layer. */
    val ModalElevation =
        "0 4px 12px rgba(0, 0, 0, 0.45), 0 28px 64px -16px rgba(0, 0, 0, 0.65)"

    val SidebarBorder = "1px solid rgba(255, 255, 255, 0.07)"

    val ChartInnerShadow = "inset 0px 4px 4px rgba(0, 0, 0, 0.35)"

    val InputFocusRing =
        "0 0 0 3px rgba(0, 97, 255, 0.35)"

    val GlassPanel =
        "backdrop-filter: blur(18px); -webkit-backdrop-filter: blur(18px);"
}
